import {
  Button,
  // Card,
  Field,
  Input,
  Stack,
  Box,
  // useBreakpointValue,
  InputGroup,
  // NativeSelect,
  Text,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon, InformationCircleIcon } from "hugeicons-react";
import { useState } from "react";
import { toaster } from "@/components/ui/toaster";
import { useLogin } from "../graphql/__generated__/Login.generated";
import { useMeLazyQuery } from "../graphql/__generated__/GetMe.generated";
import { type FC } from "react";
// import type { UserType } from "../__generated__/globalTypes";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from "react-responsive-carousel";
import { Link } from "react-router";
import { Color } from "../lib/color";
import Logo from "../assets/logo.svg";
// import img1 from "../assets/img1.jpg"
// import img2 from "../assets/img2.jpg"
// import img3 from "../assets/img3.jpg"
// import img4 from "../assets/img4.jpg"

const LoginPage: FC = () => {
  // const cardWidth = useBreakpointValue({ base: "90%", sm: "80%", md: "400px" });
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  // const [usertype, setUserType] = useState<UserType>("ADMIN");
  const [error, setError] = useState("");

  const [login] = useLogin();
  const [getUser] = useMeLazyQuery({
    onCompleted: (data) => {
      sessionStorage.setItem("data", JSON.stringify(data));
      if (data?.me?.usertype === "SUPERADMIN") {
        window.location.href = "/app/superadmin/admins";
      } else {
        window.location.href = "/app/0";
      }
    },
    onError: (error) => {
      const promise = new Promise<void>((resolve) => {
        setTimeout(() => resolve(), 1000);
      });
      toaster.promise(promise, {
        error: {
          title: "Login failed",
          description: error.message,
        },
        loading: { title: "Loading...", description: "Please wait" },
      });
    },
  });

  const handleLogin = () => {
    // setLoading(true);
    toaster.create({
      title: "Loading...",
      description: "Please wait",
    });
    console.log(username, password);
    login({
      variables: {
        username: username,
        password: password,
        usertype: "ADMIN",
      },
    })
      .then((res) => {
        if (res.data) {
          sessionStorage.setItem("token", res.data.Login.token);
          sessionStorage.setItem("refreshToken", res?.data?.Login?.refreshToken);

          const promise = new Promise<void>((resolve) => {
            setTimeout(() => resolve(), 1000);
          });
          toaster.dismiss();

          toaster.promise(promise, {
            loading: {
              title: "Logging in...",
              description: "Please wait",
            },
            success: {
              title: "Successfully Logged In!",
              description: "Looks great",
            },
          });
          getUser();
        }
      })
      .catch((error) => {
        console.log("=====......" + error.message);

        setError(error.message);

        // toaster.create({
        //   title: "Login failed",
        //   description: error.message,
        //   type: "error",
        // });
      });
  };

  return (
    <>
      <Box
        display="flex"
        height={"100vh"}
        // justifyContent="center"
        // alignItems="center"
        // minH="100vh"
        // px={4}
        // bg="gray.50"
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <Box width={{ base: "90%", sm: "90%", md: "50%" }}>
            <Box display={"flex"} gap={1} marginBottom={42}>
              <img src={Logo} height={35} width={35} />
              <Text color={Color.textColor} fontWeight={700} fontSize={"33.63px"}>
                SheetX
              </Text>
            </Box>
            <h2
              style={{
                color: Color.color,
                fontWeight: "700",
                textTransform: "uppercase",
                fontSize: "28px",
              }}
            >
              WelCome back
            </h2>
            <Text style={{ color: Color.textColor }}>
              Access your dashboard, manage bookings, and stay updated with India’s growing cold
              chain network.
            </Text>
            <form
              onSubmit={(e) => {
                if (document.activeElement && document.activeElement.tagName === "TEXTAREA") {
                  e.preventDefault();
                  return;
                }
                e.preventDefault();
                handleLogin();
              }}
            >
              <Stack color={Color.label} marginTop={5}>
                <Field.Root invalid={error ? true : false} required>
                  <Field.Label>Username/email</Field.Label>
                  <Input
                    placeholder="Enter your username or email"
                    onChange={(e) => setUsername(e.target.value)}
                    value={username}
                  />
                  <Field.ErrorText>
                    <InformationCircleIcon />
                    {error}
                  </Field.ErrorText>
                </Field.Root>
                <Field.Root invalid={error ? true : false} required>
                  <Field.Label>Password</Field.Label>
                  <InputGroup
                    endElement={
                      <Box onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                      </Box>
                    }
                  >
                    <Input
                      placeholder="Enter your password"
                      type={showPassword ? "text" : "password"}
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                    />
                  </InputGroup>
                  <Field.ErrorText>
                    <InformationCircleIcon />
                    {error}
                  </Field.ErrorText>
                </Field.Root>
                <Box display={"flex"} justifyContent={"flex-end"}>
                  <Link to={"#"} style={{ color: "white" }}>
                    Forgot password
                  </Link>
                </Box>
              </Stack>

              <Box
                marginTop={5}
                display={{ base: "block", md: "flex" }}
                justifyContent={"flex-end"}
              >
                <Button
                  // colorScheme="teal"
                  type="submit"
                  width={{ base: "full" }}
                  variant="solid"
                  bg={Color.color}
                  color={"white"}
                  _hover={{ bg: Color.hover }}
                  // onClick={handleLogin}
                >
                  Login
                </Button>
              </Box>

              <Box marginTop={6} textAlign="center">
                <Text fontSize="sm" style={{ color: "gray" }}>
                  Are you a standard user?{" "}
                  <Link
                    to="/"
                    style={{
                      color: Color.color,
                      fontWeight: "600",
                      textDecoration: "none",
                    }}
                  >
                    Log in here
                  </Link>
                </Text>
              </Box>
            </form>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default LoginPage;

{
  /* <Card.Body color="black">

        </Card.Body>



        */
}
